/* eslint-disable import/order */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiAlertTriangle } from 'react-icons/fi';

import Modal from 'components/Modal';
import SolidButton from 'components/SolidButton';

const modalProps = {
  content: {
    width: '95%',
    maxWidth: 440,
    padding: 16,
    borderRadius: 12,
  },
};

const LeaveSessionModal = ({ modalIsOpen, toggleModal, selectContent, changeViewStatus }) => {
  const { t } = useTranslation();

  const handleConfirmAction = () => {
    toggleModal();
    changeViewStatus();
    selectContent(null);
  };

  return (
    <Modal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      modalProps={modalProps}
      modalIsOpen={modalIsOpen}
      closeModal={toggleModal}
      closeable={false}
    >
      <section className="leave-session">
        <div className="leave-session__alerticon">
          <FiAlertTriangle />
        </div>
        <h2 className="leave-session_title">{t('evieApp.leaveSession.title')}</h2>
        <p className="leave-session_content">{t('evieApp.leaveSession.content')}</p>
        <div className="leave-session__actions">
          <SolidButton className="evie-primary" onClick={toggleModal}>
            {t('button.cancel')}
          </SolidButton>
          <SolidButton className="evie-secondary" onClick={handleConfirmAction}>
            Ok
          </SolidButton>
        </div>
      </section>
    </Modal>
  );
};

LeaveSessionModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  selectContent: PropTypes.func.isRequired,
  changeViewStatus: PropTypes.func.isRequired,
};

export default LeaveSessionModal;
